// extracted by mini-css-extract-plugin
export default {"spinner-ls":"lsf-spinner-ls","spinner-ls__body":"lsf-spinner-ls__body","spinner-ls__body_stopped":"lsf-spinner-ls__body_stopped","logo-spin":"lsf-logo-spin"};